import { commonShortNouns } from "./common-short-fields";
export const centersCenterEn = {
  title: "Service Entries & Center Status",
  subtitle: "Current connectivity of service entries, platform centers, and business entries from the service endpoint registry.",
  infoMessage: "The platform admin and exam admin are separated. Public entries are derived from the service endpoint registry; platform admin carries platform pages, while exam admin carries exam business operations.",
  summaryDirectProbes: "Direct backend probes",
  summaryRestricted: "Restricted entries",
  tableTitle: "Service Entry & Center Catalog",
  tableSubtitle: "Service entries, platform centers, business entries, and compatibility gateways are inventoried from the registry projection.",
  groupedTitle: "Browse by Responsibility",
  groupedSubtitle: "Review the platform shell, centers, capabilities, infrastructure, and business entries as separate groups before drilling into details.",
  drawerTitle: "{name} · Detail",
  detailBasicTitle: "Basic Status",
  detailRuntimeTitle: "Connectivity & Dependencies",
  detailProbeTitle: "Probe Detail",
  detailAccessRequirement: "Access Requirement",
  openConsole: "Open Console",
  footerHint: "The platform admin reuses the shared frontend foundation from the exam admin, but does not reuse question, paper, exam, or other business pages themselves.",
  notices: {
    signalSemantics: "Statuses on this page come from backend-aggregated probes first. Entries without direct probes are explicitly marked as shared-health, provider-dependent, or directory-only.",
    backendProbe: "Health on this page is aggregated by `/api/identity/platform-overview`. Latest check: {value}",
  },
  cards: {
    coverageTitle: "Signal Coverage",
    accessTitle: "Access Coverage",
    catalogTitle: "Catalog Composition",
    attentionTitle: "Attention Queue",
    accessReasonTitle: "Restricted Reasons",
    attentionPreviewTitle: "Current Watchlist",
    attentionPreviewDescription: "List offline, degraded, unintegrated, restricted, and directory-only entries first so triage starts in the right place.",
  },
  metrics: {
    openableEntries: "Directly openable",
    unstableEntries: "Unstable entries",
    unintegratedEntries: "Unintegrated entries",
    restrictedEntries: "Restricted entries",
    directoryOnlyEntries: "Directory-only entries",
    restrictedReasonNone: "Current access",
    none: "None",
    andMore: "+{count} more",
  },
  signal: {
    directHealth: "Direct backend probe",
    sharedHealth: "Shared health",
    providerDependency: "Provider dependency",
    directoryOnly: "Directory only",
  },
  access: {
    available: "Available",
    restricted: "Restricted",
    externalSurface: "External entry, not limited by platform admin menu permissions",
    platformManagement: "Requires platform management permission",
    platformDashboard: "Requires platform admin access",
    identity: "Requires identity center permission",
    assets: "Requires asset center permission",
    environment: "Requires environment center permission",
    execution: "Requires execution center permission",
    intelligence: "Requires intelligence center permission",
    capabilityGraph: "Requires capability graph permission",
    tacticsTechniques: "Requires tactics and techniques hub permission",
    vulnerabilityLibrary: "Requires vulnerability library permission",
    businessReference: "Requires business reference center permission",
    trafficLibrary: "Requires Traffic Library permission",
  },
  filters: {
    scope: {
      all: "All scope",
      platform: "Platform only",
      business: "Business only",
      restricted: "Restricted only",
    },
    signal: {
      all: "All signals",
    },
    access: {
      all: "All access",
      available: "Available",
      restricted: "Restricted",
    },
  },
  views: {
    list: "Full list",
    grouped: "Grouped",
  },
  groups: {
    platformEntry: {
      title: "Platform Entries",
      description: "Shell-level and unified user entries for the platform admin, portal, and account surfaces.",
    },
    platformCenter: {
      title: "Platform Centers",
      description: "Core control-plane centers with their own operational responsibilities inside the platform.",
    },
    platformCapability: {
      title: "Platform Capabilities",
      description: "Capability modules hosted on the platform shell, focused on specialized governance and analysis workflows.",
    },
    platformInfrastructure: {
      title: "Platform Infrastructure",
      description: "External infrastructure surfaces and compatibility endpoints used to confirm base connectivity.",
    },
    businessEntry: {
      title: "Business Entries",
      description: "Business service and console entries, where registry entry, reachability, and dependency mode matter most.",
    },
  },
  table: {
    name: "Service / Entry",
    category: "Category",
    domain: "Entry Domain",
    entryAddress: "Entry Address",
    status: commonShortNouns.status,
    latency: "Latency",
    signal: "Signal",
    access: "Access",
    mode: "Mode",
    phase: "Phase",
    dependencies: "Dependencies",
    note: "Note",
    actions: "Actions",
  },
} as const;
